module.exports = __webpack_public_path__ + "img/logo-nomundo.abbcf49a.png";